export const green = {
    colorTitle: '#FFFFFF',
    colorText: '#303446',
    offerBg: '#6CD206',
    offerBgLogo: '#fff',
    offerTitle: '#303446',
    offerParamsBig: '#0A0E20',
    offerParams: '#fff',
    offerParamsName: '#fff',
    offerParamsBorder: '#EBEFF3',
    offerUspBg: '#FFF7B2',
    offerUspColor: '#FFFFFF',
    approvalColor: '#303446',
    approvalPercent: '#51B204',
    btnBg: '#0A0E20',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: '#4D5163',
    btnActiveBg: '#303446',
    btnActiveColor: '#fff',
};
export const light = {
    colorTitle: '#303446',
    offerBg: '#fff',
    offerBgLogo: '#F5F7F9',
    offerBoxShadow: '0 10px 40px 0 #00000012',
    offerParams: '#303446',
    offerParamsName: '#303446',
    offerParamsBorder: '#EBEFF3',
    btnBg: '#6CD206',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: '#2DA40F',
    btnActiveBg: '#0C8411',
    btnActiveColor: '#fff',
};
export const yellow = {
    colorTitle: '#303446',
    offerBg: '#FFF7B2',
    offerBgLogo: '#F5F7F9',
    offerParams: '#303446',
    offerParamsName: '#303446',
    offerParamsBorder: '#FFBB0B',
    btnBg: '#FC7940',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: '#EC5F23',
    btnActiveBg: '#C85413',
    btnActiveColor: '#fff'
};
export const avocado = {
    colorTitle: '#0A0E20',
    offerBg: '#CAFF5B',
    offerBgLogo: '#F5F7F9',
    offerParams: '#303446',
    offerParamsName: '#303446',
    offerParamsBorder: '#7AC933',
    btnBg: '#0A0E20',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: '#4D5163',
    btnActiveBg: '#303446',
    btnActiveColor: '#fff'
};